import React, { useState } from "react";
import { Modal } from "react-bootstrap";
import { useDispatch } from "react-redux";
import { addLogHourComment } from "../../data/redux/logHour/_logHourAction";

interface AddCommentModalProps {
  show: boolean;
  onHide: () => void;
  uuid: string | null;
  onSuccess?: () => void;
}

const AddCommentModal: React.FC<AddCommentModalProps> = ({ show, onHide, uuid, onSuccess }) => {

  const dispatch: any = useDispatch();
  const [comment, setComment] = useState("");

  const handleSubmit = async () => {
    if (comment.trim()) {
      await dispatch(addLogHourComment({ uuid, comment }));
      setComment("");
      onSuccess?.();
      onHide();
    }
  };


  return (
    <Modal
      show={show}
      onHide={onHide}
      centered
    >
      <Modal.Header closeButton>
        <Modal.Title>Add Comment (Optional)</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <div className="mb-3">
          <label className="form-label">Add Comment</label>

          <textarea
            id="taskDescription"
            name="notes"
            className="form-control commonInput bg-light"
            rows={4}
            maxLength={500}
            placeholder="Add Comment"
            value={comment}
            onChange={(e) => setComment(e.target.value)}
          />
        </div>
        {/* <div className="text-end text-muted small mt-1">
          {comment?.length}/500 Characters
        </div> */}
      </Modal.Body>

      <Modal.Footer>
        <div className="modal-submit-button w-100">
          <button
            type="submit"
            className="btn btn-warning"
            onClick={handleSubmit}
            disabled={!comment.trim()}
          >
            Submit
          </button>
        </div>
      </Modal.Footer>
    </Modal>
  );
};

export default AddCommentModal;